import newraiANTDPackageEN from "@neonumy/ant-design/lib/resources/i18n/locales/en/newraiANTDPackage.json";
import newraiANTDPackageFR from "@neonumy/ant-design/lib/resources/i18n/locales/fr/newraiANTDPackage.json";
import neonumyUiTranslationsEn from "@neonumy/neonumy-ui/lib/resources/locales/en/neonumy-ui.json";
import neonumyUiTranslationsFr from "@neonumy/neonumy-ui/lib/resources/locales/fr/neonumy-ui.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "resources/locales/en/translation.json";
import translationFR from "resources/locales/fr/translation.json";

const resources = {
  en: {
    translation: translationEN,
    newraiANTDPackage: newraiANTDPackageEN,
    "neonumy-ui": neonumyUiTranslationsEn,
  },
  fr: {
    translation: translationFR,
    newraiANTDPackage: newraiANTDPackageFR,
    "neonumy-ui": neonumyUiTranslationsFr,
  },
};

const langsCode = ["fr", "en"];

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng") || langsCode[0],
    fallbackLng: langsCode,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    ns: ["translation", "newraiANTDPackage", "neonumy-ui"],
    defaultNS: "translation",
  });

export default i18n;
